import React from 'react'
import { Input } from 'antd'
import { Box } from '@mui/material'

function toHex6(value: string): string {
  const cleaned = value.replace(/^#/, '').trim()
  if (/^[a-f\d]{6}$/i.test(cleaned)) return `#${cleaned}`
  if (/^[a-f\d]{3}$/i.test(cleaned)) {
    return `#${cleaned[0]}${cleaned[0]}${cleaned[1]}${cleaned[1]}${cleaned[2]}${cleaned[2]}`
  }
  const rgb = value.match(/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i)
  if (rgb) {
    const r = Math.min(255, Math.max(0, parseInt(rgb[1], 10))).toString(16).padStart(2, '0')
    const g = Math.min(255, Math.max(0, parseInt(rgb[2], 10))).toString(16).padStart(2, '0')
    const b = Math.min(255, Math.max(0, parseInt(rgb[3], 10))).toString(16).padStart(2, '0')
    return `#${r}${g}${b}`
  }
  return '#ffffff'
}

interface ColorPickerInputProps {
  value?: string
  onChange?: (value: string) => void
  placeholder?: string
  disabled?: boolean
}

export function ColorPickerInput({
  value = '',
  onChange,
  placeholder = '#ffffff',
  disabled,
}: ColorPickerInputProps) {
  const pickerValue = value ? toHex6(value) : '#ffffff'

  const handlePickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value)
  }

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <Box
        sx={{
          position: 'relative',
          flexShrink: 0,
          width: 40,
          height: 40,
        }}
      >
        <input
          type="color"
          value={pickerValue}
          onChange={handlePickerChange}
          disabled={disabled}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            padding: 0,
            border: 'none',
            borderRadius: 8,
            cursor: disabled ? 'default' : 'pointer',
            opacity: 0,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: value || '#f5f5f5',
            cursor: disabled ? 'default' : 'pointer',
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.06)',
            pointerEvents: 'none',
          }}
        />
      </Box>
      <Input
        value={value}
        onChange={handleInputChange}
        placeholder={placeholder}
        allowClear
        disabled={disabled}
        style={{ flex: 1 }}
      />
    </Box>
  )
}
